import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { NbDialogService } from "@nebular/theme";
import { NotificationsService } from "angular2-notifications";
import { NgxSpinnerService } from "ngx-spinner";
import exportarXlsx from "../../utils/exportar-xlsx";
import { OrigemImportacaoService } from "../../utils/origem-importacao.service";
import { ModalHelpComponent } from "../modals/modal-help/modal-help.component";
import { EImportacaoType } from "../table/EImportacaoType";
import { UploadService } from "./upload.service";

@Component({
  selector: "ngx-importar-planilha",
  templateUrl: "./importar-planilha-lote.component.html",
  styleUrls: ["./importar-planilha-lote.component.scss"],
})
export class ImportarPlanilhaLoteComponent implements OnInit {
  @Input() url: string;
  @Input() urlModeloPreenchido: string;
  @Output() returnDados: EventEmitter<any> = new EventEmitter();
  @Input() importacaoType: EImportacaoType;
  @Input() showDownloadOptions: boolean = true;
  @Input() fileName?: string;
  @ViewChild("fileInput", { static: false }) fileInput?: ElementRef;
  @ViewChild("fileLabel", { static: false }) fileLabel?: ElementRef;

  modelos: { titulo: string; descricao: string; action: () => void }[] = [];

  public customLogin;
  EImportacaoType = EImportacaoType;

  constructor(
    private uploadService: UploadService,
    private spinnerService: NgxSpinnerService,
    private notifications: NotificationsService,
    private dialogService: NbDialogService,
    private origemService: OrigemImportacaoService
  ) {}

  ngOnInit() {
    const resCustom = localStorage.getItem("bway-customLogin");
    this.customLogin = JSON.parse(resCustom);

    if (this.showDownloadOptions) {
      this.loadingDownloadOptions();
    }

    this.setFileName(this.fileName);
  }

  loadingDownloadOptions() {
    const description =
      "Modelo de planilha em branco, você deve preencher todos os dados.";

    switch (this.importacaoType) {
      case EImportacaoType.FUNCIONARIO:
        this.modelos = [
          {
            titulo: "Baixar modelo .XLS (recomendado)",
            descricao: description,
            action: () =>
              this.openUrl(
                "https://www.valecard.com.br/wp-content/uploads/2025/02/Modelo-importacao-cadastro.xlsx"
              ),
          },
          {
            titulo: "Baixar modelo .CSV",
            descricao: description,
            action: () =>
              this.openUrl(
                "https://www.valecard.com.br/wp-content/uploads/2025/02/modelo-importacao-cadastro-csv.csv"
              ),
          },
        ];
        break;
      default:
        this.modelos = [
          {
            titulo: "Baixar modelo em branco",
            descricao:
              "Modelo de planilha em branco, você deve preencher todos os dados: CPF, Matrícula e valor.",
            action: () =>
              this.openUrl(
                "https://www.valecard.com.br/wp-content/uploads/2024/09/Modelo-importacao-carga-Em-branco-3.xlsx"
              ),
          },
          {
            titulo: "Baixar modelo pré-preenchido com CPF e matrícula",
            descricao: description,
            action: () => this.baixarModeloPreenchido(),
          },
        ];
        break;
    }
  }

  onUpload(files: File[]) {
    if (files[0]) {
      this.spinnerService.show();
      this.setFileName(files[0].name);
      this.uploadService.uploadFile(
        files[0],
        this.url,
        (response) => {
          this.returnDados.emit(response);
          this.spinnerService.hide();
          this.fileInput.nativeElement.value = null;
          this.setFileName("");
        },
        (error) => {
          this.fileInput.nativeElement.value = null;
          this.setFileName("");
          this.notifications.error(error.message);
          this.spinnerService.hide();
        }
      );
    } else {
      this.notifications.info("Nenhum arquivo selecionado");
    }
  }

  onUploadBase64(files: FileList) {
    this.spinnerService.show();
    const file = files.item(0);
    const reader = new FileReader();
    this.setFileName(file.name);

    let emitirCartao: string = "SIM";
    if (this.importacaoType === EImportacaoType.FUNCIONARIO) {
      emitirCartao = this.origemService.getEmitirCartao(
        this.origemService.getOrigemImportacao()
      );
    }

    reader.onload = () => {
      this.uploadService.uploadFileBase64(
        this.url,
        {
          uploadedFileBase64: (reader.result as string).split("base64,")[1],
          fileName: file.name,
          gerarCartao: emitirCartao,
        },
        (response) => {
          this.returnDados.emit(response);
          this.spinnerService.hide();
          this.fileInput.nativeElement.value = null;
          this.setFileName("");
        },
        (error) => {
          this.fileInput.nativeElement.value = null;
          this.setFileName("");
          this.notifications.error(error.message);
          this.spinnerService.hide();
        }
      );
    };
    reader.readAsDataURL(file);
  }

  openModal() {
    this.dialogService.open(ModalHelpComponent, {
      closeOnBackdropClick: false,
      closeOnEsc: false,
      context: {
        importacaoType: this.importacaoType,
      },
    });
  }

  baixarModeloPreenchido() {
    this.uploadService.buscarDadosModeloPreenchido(
      this.urlModeloPreenchido,
      (response) => {
        const dados = response.map((d) => {
          return {
            CPF: d.cpf,
            MATRICULA: d.matricula,
            VALOR: d.valor,
          };
        });
        exportarXlsx(dados, "Modelo Importação");
      }
    );
  }

  setFileName(name?: string) {
    if (name && this.fileLabel && this.fileLabel.nativeElement) {
      this.fileLabel.nativeElement.innerText = name;
    }
  }

  openUrl(url: string) {
    window.open(url, "_blank");
  }
}
